import o, { useRef as m, useEffect as l } from "react";
import { useAtomValue as u, useSetAtom as f } from "jotai";
import { getToastsAtom as T, setToastAtom as d } from "./index65.mjs";
import { TOASTS_LIMIT as g, TOAST_DURATION as c } from "./index125.mjs";
import { Toast as p } from "./index90.mjs";
import i from "./index126.mjs";
const E = () => {
  const r = m(), a = m(), t = u(T), n = f(d);
  return l(() => {
    if (t.length) {
      const e = t.length > g;
      r.current = setInterval(
        () => {
          const s = document.getElementById(
            `toast-${t.length - 1}`
          );
          s && (s.style.opacity = "0", a.current = setTimeout(() => {
            n(null);
          }, 200));
        },
        e ? c / 3 : c
      );
    }
    return () => {
      clearTimeout(a.current), clearInterval(r.current);
    };
  }, [n, t.length]), t.length === 0 ? null : /* @__PURE__ */ o.createElement("div", { "data-testid": "toasts", className: i.toasts }, /* @__PURE__ */ o.createElement("div", { "data-testid": "toasts-container", className: i.container }, t.map((e, s) => /* @__PURE__ */ o.createElement(
    p,
    {
      index: s,
      message: e.message,
      state: e.state,
      key: e.id
    }
  ))));
};
export {
  E as Toasts
};
